export const peugeot_api_url = 'http://api.phutungpeugeot.com/api';
export const peugeot_software = 1;
export const peugeot_site = 1;


// WEBPACK FOOTER //
// ./src/peugeot_constants.js